import api from '@pray/shared/utils/api';

export async function getArtistImpactMetrics({ artistId = '' }) {
  if (!artistId) throw new Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/impact-metrics`;
  const response = await api.executeGetRequest(url);

  return response.data;
}
